<template lang="pug">
  v-container.px-10(fluid)
    v-progress-linear(
      :active="loading",
      indeterminate,
      color="primary",
      absolute,
      top
    )
    v-row.pb-10.pt-5.align-self-start(align="center", v-if="entity")
      v-col.py-0.text-right
        v-btn(color="white", @click="save()", :disabled="loading") {{ $t('Common.save') }}

    v-row(v-if="!loading")
      v-col.py-0
        v-card.elevation-24.mb-5(style="overflow: visible")
          app-full-entity(:entity="entity", :instance="instance")
            template(v-slot:Dashboard="props")
              v-form
                v-row
                  v-col
                    h2.display-1.font-weight-light.underline.underline--black {{ $t('Dashboard.information') }}
                v-row(justify-end)
                  v-col(cols="4")
                    v-text-field(
                      :label="$t('Dashboard.title')",
                      v-model="instance.title",
                      :error-messages="errors['dashboard.title']",
                    )
                  v-col(cols="4")
                    v-text-field(
                      :label="$t('Dashboard.description')",
                      v-model="instance.description",
                      :error-messages="errors['dashboard.description']",
                    )
                  v-col(cols="4")
                    v-text-field(
                      :label="$t('Dashboard.size')",
                      v-model="instance.size",
                      type="number",
                      :error-messages="errors['dashboard.sizeChartsConfig']",
                    )
                v-row(justify-end)
                  v-col
                    h2.display-1.font-weight-light {{ $t('Dashboard.addChart') }}
                  v-col
                    v-btn.primary(fab, x-small, @click="addField()")
                      v-icon  mdi-plus
                v-row(v-for="(field, i) in instance.fields")
                  v-btn.delete-button(color="red", outlined, x-small, fab, @click="deleteField(i)")
                    v-icon  mdi-delete
                  v-col(cols="8")
                    v-select(
                      :items="charts",
                      item-text="name",
                      return-object,
                      :label="$t('Dashboard.selectChart')",
                      v-model="field.name",
                      @input="setFieldName(field, $event)"
                    )
                  v-col(cols="4")
                    v-text-field(
                      :label="$t('Dashboard.sizeColumns')",
                      :value="field.value",
                      type="number"
                      @input="setValue(field, $event)",
                     )
                v-card
                  v-row
                    v-col
                      h2.display-1.font-weight-light.underline.underline--black {{ $t('Dashboard.previewTitle') }}
                  v-row
                    v-col.py-0.text-right
                      v-btn(color="blue", @click="dashboardPreview") {{ $t('Dashboard.preview') }}
                  v-card(v-if="isPreview")
                    v-row
                      v-col(:cols="dashboardSize")
                        v-card(
                          class="pa-1"
                          outlined
                          tile
                        )
                          v-row
                            v-col(v-for="chart in instance.fields" :cols="chart.value")
                              v-card(
                                class="pa-1"
                                color="blue-grey lighten-5"
                                outline
                              )
                                GChart(
                                  v-if="chart.type"
                                  :type="chart.type"
                                  :data="chart.data"
                                  :options="chart.options"
                                )
                                pre {{chart.value}} {{ $t('Dashboard.columns') }}

</template>


<style lang="sass">
.delete-button
  position: absolute
  right: 15px
</style>

<script>
import { assign } from "lodash/assign";
import axios from "axios";
import { mapGetters } from "vuex";
import { GChart } from "vue-google-charts";
import ChartMixin  from '@/mixins/chart.mixin.js'

export default {
  name: "entity-add",
  mixins: [ChartMixin],
  data: function() {
    return {
      loading: true,
      extraFields: [],
      errors: {},
      isPreview: false,
      dashboardSize: null
    };
  },
  computed: {
    instance: {
      get() {
        return this.$store.state.instance || {};
      },
      set(instance) {
        this.$store.commit("SET_INSTANCE", instance);
      }
    },
    chartParams(){
      return {pageSize:1000}
    },
    entityName() {
      return "Dashboard";
    },
    entity() {
      return this.$searchEntity(this.entityName, "name", false);
    },
    uid() {
      return this.$route.params.item;
    },
    isDataComplete: function() {
      return true;
    },
    isSaveable: function() {
      return !this.loading && this.isDataComplete;
    }
  },
  components: {
    GChart
  },
  methods: {
    addField() {
      this.instance = {
        ...this.instance,
        fields: [...this.instance.fields, { name: "", value: "" }]
      };
    },
    deleteField(index) {
      this.instance.fields.splice(index, 1);
      this.setSizeChartsConfig();
    },
    setFieldName(field, $event) {
      field.name = $event.name;
      field._Entity = $event._Entity;
      field.id = $event.id;
      this.setSizeChartsConfig();
    },
    setValue(field, $event) {
      var inputValue = $event;
      field.value = inputValue;
      this.setSizeChartsConfig();
    },
    setSizeChartsConfig() {
      this.instance.sizeChartsConfigArray = [];
      for (var field in this.instance.fields) {
        this.instance = {
          ...this.instance,
          sizeChartsConfigArray: [
            ...this.instance.sizeChartsConfigArray,
            {
              chartId: this.instance.fields[field].id,
              size: Number(this.instance.fields[field].value)
            }
          ]
        };
      }
    },
    initInstance() {
      return {
        _Entity: this.entityName,
        ...this.instance,
        userId: this.$store.state.user.user.id,
        entityState:
          this.instance && this.instance.id
            ? ENV.ENTITY.STATE.UNCHANGED
            : ENV.ENTITY.STATE.ADDED
      };
    },
    async dashboardPreview() {
      this.isPreview = true;
      this.dashboardSize = this.instance.size;
      this.instance.fields = await this.getCharts(this.instance.sizeChartsConfigArray,this.chartParams);
    },
    /* TODO: docs */
    update(instance, entity) {
      this.instance = assign(
        {},
        this.instance,
        entity ? { [entity]: instance } : instance
      );
    },

    /* TODO: docs */
    async save() {
      this.loading = true;
      this.instance.sizeChartsConfig = JSON.stringify(this.instance.sizeChartsConfigArray);
      try {
        this.instance = (await axios.post("entity/graph", this.instance)).data;
        this.$router.push({
          name: "entities.index",
          params: { entity: this.entity.name }
        });
      } catch (error) {
        this.errors = error.response.data.errors;
      }
      this.loading = false;
    },

    /* TODO: docs */
    async load() {
      if (this.uid) {
        try {
          this.instance.uid = this.uid;
          this.instance = {
            ...this.instance,
            ...(
              await axios.get(`${this.entity.name}/${this.uid}`, {
                _Entity: this.entity.name,
                uid: this.uid
              })
            ).data
          };
          this.instance.entityState = ENV.ENTITY.STATE.MODIFIED;
          this.instance.fields = await this.getCharts(JSON.parse(this.instance.sizeChartsConfig),this.chartParams);
          this.setSizeChartsConfig();
        } catch (error) {
          console.error(error);
        }
      } else this.$store.commit("SET_INSTANCE", { fields: [] });
      this.loading = false;
    }
  },
  async created() {
    await this.loadCharts(this.chartParams);
    this.instance = this.initInstance();
    this.$watch("instance", {
      deep: true,
      handler(instance) {
        if (
          instance &&
          instance.id &&
          instance.entityState != ENV.ENTITY.STATE.MODIFIED
        )
          instance.entityState = ENV.ENTITY.STATE.MODIFIED;
      }
    });
    setTimeout(() => {
      this.load();
    }, 1000);

  },
};
</script>
